module.exports = __webpack_public_path__ + "img/expert_head.51083b8c.png";